import { FullScreenPopupComponent } from './../../Modalla-Popup/full-screen-popup/full-screen-popup.component';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { CONSTANTS } from 'src/Core/Constant';
import { environment } from 'src/environments/environment';
import { ConfirmApprovalModalComponent } from '../../Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { ConfirmationModalComponent } from '../../Modalla-Popup/confirmation-modal/confirmation-modal.component';
import { FormApprovalSuccessModalComponent } from '../../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { COUNTRY_DIAL_CODES } from 'src/Core/CountryCodes';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent {

  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  referencesForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  toogleBool: boolean = true;
  selectedLanguage: string = 'en'; // Default language
  countryCodeOptions = COUNTRY_DIAL_CODES;
  isEditable: boolean = true; // Flag to track if the form is editable
  @Output() navigateToFirstTab: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateToInvalidTab = new EventEmitter<any>();
  

  constructor(
    private toastr: ToastrService, 
    private api: SevaProfileService, 
    private fb: FormBuilder, 
    public genericValidations: GenericValidationsService, 
    private dialogService: NbDialogService, 
    private router: Router,
    private translationService: TranslationService
  ) { }



  ngOnInit(): void {
    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();

    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.getApplicantData();
    }
  }

  // Get translation for current language
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {

      this.initializeForm();
      this.referencesForm.patchValue(this.applicantData);
      this.referencesForm.disable();
    }
  }



  getApplicantData() {
    this.api.apiCall('Reference/GetUserReference', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.referencesForm.disable();
        } else {
          this.referencesForm.enable();
        }

        this.referencesForm.patchValue(response.Data);
      }
    })
  }

  initializeForm() {
    this.referencesForm = this.fb.group({
      Reference1Name: ['', Validators.required],
      Reference1Email: ['', [Validators.email]],
      CountryCodeReference1: ['+91', Validators.required],
      Reference1Phone: ['', [Validators.required, Validators.pattern(/^[7-9][0-9]{9}$/), Validators.maxLength(10)]],
      Reference1Relationship: ['', Validators.required],
      Reference2Name: ['', Validators.required],
      Reference2Email: ['', [Validators.email]],
      CountryCodeReference2: ['+91', Validators.required],
      Reference2Phone: ['', [Validators.required, Validators.pattern(/^[7-9][0-9]{9}$/), Validators.maxLength(10)]],
      Reference2Relationship: ['', Validators.required],
      IsRefernceConcentGiven: [false, this.genericValidations.checkboxValidator('SaveMode', this.SaveMode.SAVE)],
      RefernceConcentGivenDate: [new Date().toISOString()],

      SaveMode: ['', [Validators.required,]],

    });
  }

  // Instead of method inside component
  shouldShowCheckboxValidation(): boolean {
    return this.genericValidations.shouldShowCheckboxValidation(
      this.referencesForm,
      'IsRefernceConcentGiven',
      'SaveMode',
      this.SaveMode.SAVE,
      this.submitted
    );
  }
  

  onSubmit(Mode: number): void {

    // this.referencesForm.patchValue({
    //   SaveMode: Mode
    // })


      // ✅ force re-check validation for checkbox
  this.referencesForm.get('IsRefernceConcentGiven')?.updateValueAndValidity();

    if (!this.referencesForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;


      // Add 'submitted' class manually to all invalid controls
      Object.keys(this.referencesForm.controls).forEach((field) => {
        const control = this.referencesForm.get(field);
        if (control && control.invalid) {
          control.markAsTouched(); // Ensure ng-touched is triggered
          const element = document.getElementById(field);
          if (element) {
            element.classList.add('submitted'); // Add 'submitted' class to invalid elements
          }
        }
      });
      this.toastr.warning(this.getTranslation('validation.completeAllFields'));

      return
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.referencesForm.value);

    if (Mode == this.SaveMode.SAVE) {

      this.addUpdate(cleanedValues, Mode);


      // this.OpenModal(cleanedValues, Mode);
    } else {

      this.addUpdate(cleanedValues, Mode);
    }
  }

  addUpdate(reqBoby: any, Mode: number) {
    reqBoby.SaveMode = Mode;
    this.api.apiCall('Reference/saveReference', 'POST', reqBoby).subscribe((response: any) => {
      this.toastr.success(response?.Message);

    

        if (Mode === this.SaveMode.SAVE) {
          this.nextStep.emit();
        } else if (Mode === this.SaveMode.DRAFT) {
          this.getApplicantData();
        }
      
    });
  }





  goToBack(): void {
    this.previous.emit();
  }

  // Country code change handlers for Reference 1
  onCountryCodeChangeRef1(selection: any): void {
    const code = typeof selection === 'string' ? selection : selection?.code || '';
    this.referencesForm.patchValue({ CountryCodeReference1: code });
    this.setPhoneValidatorsForCode('Reference1Phone', code);
  }

  // Country code change handlers for Reference 2
  onCountryCodeChangeRef2(selection: any): void {
    const code = typeof selection === 'string' ? selection : selection?.code || '';
    this.referencesForm.patchValue({ CountryCodeReference2: code });
    this.setPhoneValidatorsForCode('Reference2Phone', code);
  }

  searchCountry = (term: string, item: { code: string; country: string }) => {
    const value = term?.toLowerCase().trim();
    if (!value) return true;
    return (
      item.code.toLowerCase().includes(value) ||
      item.country.toLowerCase().includes(value)
    );
  };

  private setPhoneValidatorsForCode(phoneControlName: string, code: string): void {
    const phoneCtrl = this.referencesForm.get(phoneControlName);

    if (!code || code === '') {
      // If no country code selected, use default validators
      phoneCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{8,15}$'),
        Validators.maxLength(15)
      ]);
    } else if (code === '+91') {
      phoneCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[7-9][0-9]{9}$'),
        Validators.maxLength(10)
      ]);
    } else {
      phoneCtrl?.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{8,15}$'),
        Validators.maxLength(15)
      ]);
    }

    phoneCtrl?.updateValueAndValidity();
  }

  // Mobile number formatting
  onlyNumbers(event: KeyboardEvent): boolean {
    const key = event.key;
    return /^\d$/.test(key) || key === 'Backspace' || key === 'ArrowLeft' || key === 'ArrowRight';
  }

  formatPhoneNumber(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const clean = input.value.replace(/\D/g, '');
    input.value = clean;
    this.referencesForm.patchValue({ [controlName]: clean });
  }




}
